module.exports = __webpack_public_path__ + "static/media/hp_01.f992ecbe.jpg";